import type { ReactNode } from 'react'

/**
 * Centered, modern login surface shared by the dedicated /login route and the
 * auth gate that fronts the dashboard. Fully responsive — looks identical and
 * stays centered on web and phone.
 */
export default function LoginShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-[100dvh] bg-slate-200 dark:bg-slate-950 flex items-center justify-center px-4 py-10 sm:py-12 relative overflow-hidden">
      {/* Ambient background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-[-25%] left-[-15%] w-[60vw] max-w-[640px] aspect-square bg-blue-600/15 rounded-full blur-[120px]" />
        <div className="absolute bottom-[-25%] right-[-15%] w-[60vw] max-w-[640px] aspect-square bg-indigo-600/15 rounded-full blur-[120px]" />
        <div
          className="absolute inset-0 opacity-[0.035]"
          style={{
            backgroundImage:
              'linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)',
            backgroundSize: '44px 44px',
            maskImage: 'radial-gradient(ellipse 70% 60% at 50% 40%, #000 40%, transparent 100%)',
            WebkitMaskImage: 'radial-gradient(ellipse 70% 60% at 50% 40%, #000 40%, transparent 100%)',
          }}
        />
      </div>

      {/* Login card */}
      <div className="relative w-full max-w-[26rem]">
        <div className="relative bg-white/70 dark:bg-slate-900/70 backdrop-blur-2xl border border-slate-300/60 dark:border-white/10 rounded-3xl p-7 sm:p-10 shadow-2xl shadow-slate-400/40 dark:shadow-black/40">
          {/* Top sheen */}
          <div className="absolute inset-x-8 top-0 h-px bg-gradient-to-r from-transparent via-white/25 to-transparent" />

          {/* Brand mark + welcome */}
          <div className="text-center mb-7 sm:mb-8">
            <div className="relative w-14 h-14 sm:w-16 sm:h-16 mx-auto mb-5">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl blur-md opacity-40" />
              <div className="relative w-full h-full bg-gradient-to-br from-blue-500 to-indigo-600 rounded-2xl flex items-center justify-center text-white font-bold text-xl sm:text-2xl ring-1 ring-white/15 shadow-lg shadow-blue-500/25">
                NB
              </div>
            </div>
            <h1 className="text-xl sm:text-2xl font-bold text-slate-900 dark:text-white tracking-tight">Welcome back, Nate</h1>
            <p className="text-slate-500 dark:text-slate-400 text-sm mt-2">Sign in to your dashboard</p>
          </div>

          {/* Auth form */}
          <div className="nb-login-form">{children}</div>
        </div>

        <p className="text-center text-slate-400 dark:text-slate-600 text-xs mt-6">nathanaelbrown.info</p>
      </div>
    </div>
  )
}
